function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoChartBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2wqzfnwmwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-graph-bar-up-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-graph-bar-up-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#2wqzfnwmwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 12H9.509a.671.671 0 0 1-.472-.195.665.665 0 0 1-.2-.472V.667a.665.665 0 0 1 .2-.472A.671.671 0 0 1 9.509 0h1.825A.666.666 0 0 1 12 .667v10.666a.666.666 0 0 1-.667.667zm-4.42 0H5.088a.666.666 0 0 1-.667-.667V3.824a.671.671 0 0 1 .2-.471.663.663 0 0 1 .472-.2h1.82a.663.663 0 0 1 .472.2.671.671 0 0 1 .2.471v7.509a.666.666 0 0 1-.672.667zm-4.422 0H.667A.666.666 0 0 1 0 11.333v-4.35a.671.671 0 0 1 .195-.472.665.665 0 0 1 .472-.195h1.824a.666.666 0 0 1 .667.667v4.351a.665.665 0 0 1-.2.472.671.671 0 0 1-.467.194z",
    transform: "translate(2 2.167)",
    style: {
      fill: "#232323"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChartBk);
export default __webpack_public_path__ + "static/media/ico-chart-bk.1eb920c1ac24fdd00fa9a284f361937f.svg";
export { ForwardRef as ReactComponent };